import { Drawer } from "antd";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";

const CustomDrawer = (props) => {
  useBodyScrollLock(props.open);

  return <Drawer {...props} />;
};

export default CustomDrawer;
